// shared.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotifyUserUpdation {
  // Create a subject to emit events
  private userCreatedSource = new Subject<any>();
  private userDeletedSource = new Subject<any>();
  
  // Observable that components can subscribe to
  userCreated$ = this.userCreatedSource.asObservable();
  userDeleted$ = this.userDeletedSource.asObservable();
  
  // Method to call when a user is created
  notifyUserCreated(userData: any) {
    this.userCreatedSource.next(userData);
  }

  notifyUserDeleted(userData: any) {
    this.userDeletedSource.next(userData);
  }
}